import * as React from 'react';
import { connect } from 'react-redux';
import { formatDate, newDate } from '../calendar.model.js';
import { timeFormatSettings } from '../../settings/settings.consts.js';

class TimeRow extends React.Component<Props> {
  render() {
    const { show, utc, filter, timezone, user, days, location, locationsSchedule } = this.props;

    const daysSpecified =
      location && locationsSchedule && locationsSchedule[location]
        ? locationsSchedule[location].days
        : days;

    const daysListSpecified = Object.keys(daysSpecified);

    return show ? (
      <div>
        <div className="calendar-row">
          {daysListSpecified.map(date => {
            const day = daysSpecified[date];
            const timeStepsList = Object.keys(day.timeSteps);

            return timeStepsList.map((stepTimestamp, i) => {
              const step = day.timeSteps[stepTimestamp];

              const hours = newDate(
                stepTimestamp,
                utc ? 0 : filter ? timezone.offset : step.timezoneOffset
              ).getHours();

              return i % 2 === 0 ? (
                <div
                  key={`time-row-${stepTimestamp}-${i}`}
                  className={`calendar-day-hour text-center ${
                    !hours ? 'calendar-day--last-item-in-day' : ''
                  }`}
                >
                  {utc
                    ? formatDate(
                        step.unixTimestamp,
                        0,
                        timeFormatSettings[`${user.settings.time}-no-minutes`],
                        true
                      )
                    : formatDate(
                        step.unixTimestamp,
                        step.timezoneOffset,
                        timeFormatSettings[`${user.settings.time}-no-minutes`]
                      )}
                </div>
              ) : null;
            });
          })}
        </div>
      </div>
    ) : null;
  }
}

const mapStateToProps = state => ({
  timezone: state.timezone,
  user: state.user
});

export default connect(
  mapStateToProps,
  {}
)(TimeRow);
